import { Component, Input } from '@angular/core';
import { EntityRelationChangeTransactionDto } from '../../models/entity-relation-change-transaction-dto';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-entity-relation-change-transaction-details',
  imports: [],
  templateUrl: './entity-relation-change-transaction-details.component.html',
  styleUrl: './entity-relation-change-transaction-details.component.scss'
})
export class EntityRelationChangeTransactionDetailsComponent {

  @Input()
  entityRelationChangeTransactionDetails: EntityRelationChangeTransactionDto | null = null;
  @Input()
  lastModified: string = '';
  @Input()
  isReadonly: boolean = true;

  constructor() { }
}
